import { VENDOR_BOOKINGS_DATA_ALRAJHI_ACCEPT, VENDOR_BOOKINGS_DATA_SUCCESS_ALRAJHI_ACCEPT, VENDOR_BOOKINGS_DATA_ERROR_ALRAJHI_ACCEPT, VENDOR_BOOKINGS_DATA_EMPTY_ALRAJHI_ACCEPT } from '../../actionType';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetVendorBookingsAlrajhiAccept = (state = initialState, action) => {
  switch (action.type) {
    case VENDOR_BOOKINGS_DATA_ALRAJHI_ACCEPT:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case VENDOR_BOOKINGS_DATA_SUCCESS_ALRAJHI_ACCEPT:
      state = {
        ...state,
        data: action?.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case VENDOR_BOOKINGS_DATA_ERROR_ALRAJHI_ACCEPT:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action?.payload,
      };
      break;

    case VENDOR_BOOKINGS_DATA_EMPTY_ALRAJHI_ACCEPT:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetVendorBookingsAlrajhiAccept;
